import { AxiosResponse } from 'axios';
import { api } from './api';
import { authHeader } from './auth-header';
import {
  LocationAddress,
  LocationsData,
  UpdateSettingsRequest,
} from '../store/queryModels';

const url = 'api/UserQueries';

export const getQueries = async (): Promise<AxiosResponse<LocationsData[]>> => {
  return await api.get(url, authHeader());
};

export const createQuery = async (): Promise<AxiosResponse<string>> => {
  return await api.post(url, {}, authHeader());
};

export const updateQuerySettings = async (
  userQueryId: string,
  settings: UpdateSettingsRequest,
): Promise<AxiosResponse<LocationsData>> => {
  return await api.put(`${url}/${userQueryId}`, settings, authHeader());
};

export const addDestination = async (
  userQueryId: string,
  address: LocationAddress,
): Promise<AxiosResponse<LocationsData>> => {
  return await api.post(
    `${url}/${userQueryId}/destination`,
    address,
    authHeader(),
  );
};

export const deleteDestination = async (
  userQueryId: string,
): Promise<AxiosResponse<LocationsData>> => {
  return await api.delete(`${url}/${userQueryId}/destination`, authHeader());
};

export const addOrigin = async (
  userQueryId: string,
  address: LocationAddress,
): Promise<AxiosResponse<LocationsData>> => {
  return await api.post(`${url}/${userQueryId}/origin`, address, authHeader());
};

export const deleteOrigin = async (
  userQueryId: string,
  originId: string,
): Promise<AxiosResponse<LocationsData>> => {
  return await api.delete(
    `${url}/${userQueryId}/origin/${originId}`,
    authHeader(),
  );
};
